import { v4 } from "uuid";

import {
  OfferDto,
  OfferProductDto,
  OnsiteEditDto,
  OnsiteInjectionDto,
  UserInterfaceDto,
} from "@intelligems/ig-types";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IDraftOfferState } from "./types";

const initialState: IDraftOfferState = {
  offer: null,
  offerProducts: [],
  userInterfaces: [],
  onsiteInjections: [],
  onsiteEdits: [],
};

const draftOfferSlice = createSlice({
  name: "draftOffer",
  initialState,
  reducers: {
    setDraftOffer: (
      draft,
      action: PayloadAction<{
        offer: OfferDto;
        offerProducts: OfferProductDto[];
        userInterfaces: UserInterfaceDto[];
        onsiteInjections: OnsiteInjectionDto[];
        onsiteEdits: OnsiteEditDto[];
      }>
    ) => {
      const {
        offer,
        offerProducts,
        userInterfaces,
        onsiteInjections,
        onsiteEdits,
      } = action.payload;
      draft.offer = {
        ...offer,
        id: "draft",
        variationId: "draft",
      };
      draft.offerProducts = offerProducts;
      draft.userInterfaces = userInterfaces;
      draft.onsiteInjections = onsiteInjections;
      draft.onsiteEdits = onsiteEdits;
    },
    resetDraftOffer: (draft) => {
      draft.offer = null;
      draft.offerProducts = [];
      draft.userInterfaces = [];
      draft.onsiteInjections = [];
      draft.onsiteEdits = [];
    },
  },
  selectors: {
    selectedDraftOffer: (state) => state.offer,
    selectedDraftOfferProducts: (state) => state.offerProducts,
    selectedDraftUserInterfaces: (state) => state.userInterfaces,
    selectedDraftOnsiteInjections: (state) => state.onsiteInjections,
    selectedDraftOnsiteEdits: (state) => state.onsiteEdits,
    selectedHasDraftOffer: (state) => state.offer !== null,
    selectedDraftOfferState: (state) => state,
  },
});

export const { setDraftOffer, resetDraftOffer } = draftOfferSlice.actions;

export const draftOfferReducer = draftOfferSlice.reducer;

export const {
  selectedDraftOffer,
  selectedHasDraftOffer,
  selectedDraftOfferState,
} = draftOfferSlice.selectors;
